import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-order-admin',
  templateUrl: './order-admin.component.html',
  styleUrls: ['./order-admin.component.css']
})
export class OrderAdminComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
